import {
    Dialog,
    Grid,
    Typography,
    TableCell,
    TableRow,
    TableBody,
    TableHead,
    Checkbox,
    Table,
    Button
} from "@material-ui/core"
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { desSeleccionarContrato, fetchTraerContratacionIngresoXPresupuesto } from "../../../actions/contrataciones/contrataciones";
import { ModalDocumentacion } from "../Documentacion/ModalDocumentacion";
import { ModalCargarCotizacion } from "./ModalCargarCotizacion";

let contador = 0;
export const ModalMostrarDatosCotizacionAceptada = (props) => {
    const dispatch = useDispatch();
    const { dataContrato } = useSelector((state) => state.contrataciones);
    const { cotizacion } = props;
    let oferentes = [];
    const [precioTotal, setPrecioTotal] = useState(0)
    const [openDocumentacion, setDocumentacionAlta] = useState({});
    const [open, setOpen] = useState(false);
    const [idOferenteEdicion, setIdOferenteEdicion] = useState(false);

    const handleOpenDocumentacion = (idOferente) => {
        setDocumentacionAlta(prev => ({ ...prev, [idOferente]: true }));
    };

    const handleCloseDocumentacion = (idOferente) => {
        setDocumentacionAlta(prev => ({ ...prev, [idOferente]: false }));
    };

    if (cotizacion) {
        cotizacion.cabeceraCotizacion.map((item) => {
            if (item.aceptado === true) {
                oferentes = oferentes.concat(item.oferentes);
            }
            return null
        })
    }
    useEffect(() => {
        contador = 0;
        oferentes.forEach((o) => {
            cotizacion.cabeceraCotizacion.forEach((detalle) => {
                if (detalle.oferentes.idOferente === o.idOferente) {
                    detalle.detalleCotizaciones.forEach((a) => {
                        if (a.aceptado) {
                            contador += a.cantidadCotizada * a.valorUnitario;
                        }
                    });
                }
                if (o.cuit === 88888888888) {
                    dispatch(fetchTraerContratacionIngresoXPresupuesto(detalle.idEfectorFacturacion)) //solo para las cotizaciones express
                }
            });
        });
        setPrecioTotal(contador)
    }, [])

    const handleItemSelect = (item) => {
        setOpen(true);
        setIdOferenteEdicion(item);
    }

    useEffect(() => {
        dispatch(desSeleccionarContrato())

    }, [cotizacion.cabeceraCotizacion?.idEfectorFacturacion]);

  return (
        < Dialog
            fullWidth
            maxWidth={'lg'}
            open={props.open}
            onClose={props.handleClose}
        >
            <Grid>
                <Typography variant="h5" align="center" style={{ margin: '0.5rem', padding: '0.5rem' }}>Cotizacion N° {props.idSolicitud}</Typography>
                {oferentes.map((o) => {
                    return (
                        <Grid style={{ marginTop: '1rem' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleOpenDocumentacion(o.idOferente)}
                                style={{ float: "right", margin: "1rem" }}
                            >
                                Documentacion
                            </Button>
                            {
                                openDocumentacion[o.idOferente] && (
                                    <ModalDocumentacion
                                        open={openDocumentacion[o.idOferente]}
                                        closeModalHandler={() => handleCloseDocumentacion(o.idOferente)}
                                        idCotizacionCabecera={cotizacion.cabeceraCotizacion.find(x => x.idOferente === o.idOferente)?.idCabeceraCotizacion}
                                        idOferente={o.idOferente}
                                        idEstado={cotizacion.idEstado}
                                    />
                                )
                            }
                            {open &&
                                (
                                    <ModalCargarCotizacion
                                        open={open}
                                        closeModalHandler={() => {
                                            setOpen(false);
                                        }}
                                        cabeceraCotizacion={cotizacion.cabeceraCotizacion}
                                        idSolicitud={props.idSolicitud}
                                        idEstado={cotizacion.idEstado}
                                        cotizacion={null}
                                        esEdicion={true}
                                        idOferenteEdicion={idOferenteEdicion}
                                    />
                                )
                            }
                            <Table container size="small">
                                <TableHead>
                                    <TableRow>
                                        {
                                            o.cuit !== 88888888888 ?
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '1rem', color: '#68389F' }} >{`${o.razonSocial.toUpperCase()} - ${o.cuit}`}</TableCell>
                                                :
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '1rem', color: '#68389F' }} >{`${dataContrato?.razonSocial.toUpperCase()} - ${dataContrato?.cuit}`}</TableCell>
                                        }
                                        <TableCell></TableCell>
                                        <TableCell ></TableCell>
                                        <TableCell ></TableCell>
                                        <TableCell ></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Material</TableCell>
                                        <TableCell>Cantidad Cotizada</TableCell>
                                        <TableCell>Valor Unitario</TableCell>
                                        <TableCell>Precio Final</TableCell>
                                        <TableCell ></TableCell>
                                        <TableCell><Button variant="contained"
                                            color="primary" onClick={() => handleItemSelect(cotizacion.cabeceraCotizacion.find((a) => a.idOferente === o.idOferente).idOferente)}>Editar</Button></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        cotizacion.cabeceraCotizacion.map((detalle) => (
                                            detalle.oferentes.idOferente === o.idOferente &&
                                            detalle.detalleCotizaciones.map((a, index) => {
                                                if (a.fechaBaja === null) {
                                                    return (
                                                        <React.Fragment>
                                                            <TableRow>

                                                            </TableRow>
                                                            <TableRow
                                                                key={index}
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                            >
                                                                <TableCell>{a.materiales?.descripcion}</TableCell>
                                                                <TableCell>{a.cantidadCotizada}</TableCell>
                                                                <TableCell>{a.valorUnitario}</TableCell>
                                                                <TableCell>${a.cantidadCotizada * a.valorUnitario}</TableCell>
                                                                <TableCell>
                                                                    <Checkbox
                                                                        name="aceptado"
                                                                        checked={a.aceptado}
                                                                        disabled={true}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </React.Fragment>
                                                    )
                                                }
                                                return null
                                            })
                                        ))}
                                </TableBody>
                            </Table>
                        </Grid>
                    )
                })}
                <Grid align="center" style={{ marginTop: '2rem' }}>
                    <Typography style={{ fontWeight: 'bold', fontSize: '1rem' }}> Total: ${precioTotal}</Typography>
                </Grid>
            </Grid>
            <ValidatorForm>
                <Grid container style={{ padding: '15px' }}>
                    <Grid item xs={12}>
                        <TextValidator
                            value={cotizacion.observacionesDeAceptacion}
                            margin="normal"
                            label="Motivo de Aceptacion"
                            name="observaciones"
                            autoComplete="off"
                            fullWidth
                            multiline
                            rowsMax={8}
                            disabled={true}
                        />
                    </Grid>
                </Grid>
                <Grid container style={{ padding: '15px' }}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="inherit"
                                onClick={props.closeModalHandler}>
                                Cerrar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </Dialog >
    );
}